import React, { useState, useEffect } from "react";
import { InputNumber } from "@loanbossinc/component-library";

export const EditableCell = ({
  value: initialValue,
  row: { index },
  column: { id },
  updateMyData // This is a custom function that we supplied to our table instance
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState(initialValue);

  const onChange = e => {
    setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = e => {
    updateMyData(index, id, value, e);
  };

  // If the initialValue is changed external, sync it up with our state
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return <InputNumber
    variant="filled"
    id="spread-value"
    name="spread-value"
    fullWidth
    decimals={4}
    onChange={onChange}
    onBlur={onBlur}
    value={value}
  />;
};

